import { Component, OnInit, Input } from "@angular/core";
import { EfficacyCriteria } from "../../store/students/state";

@Component({
  selector: "criteria-display-text",
  templateUrl: "./criteria-display-text.component.html",
  styleUrls: ["./criteria-display-text.component.scss"],
})
export class CriteriaDisplayTextComponent implements OnInit {
  @Input() criteria: EfficacyCriteria;
  @Input() column;
  @Input() displaySymbols: boolean;
  @Input() colourText: boolean;

  constructor() {}

  ngOnInit() {}

  convertString(value) {
    return parseFloat(value).toFixed(1);
  }
}
